var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 52,
    viewBox: "0 0 42 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6451 6.92811C41.5021 2.85885 39.9376 0.637834 35.5904 0.291413C31.244 -0.054332 20.4285 0.308293 17.0154 0.774239C14.1031 1.17131 10.7395 4.31544 7.42724 7.63649C5.23226 9.83792 0.0300568 14.5521 0.0616771 17.759C0.0939562 20.9666 -0.0490004 42.0659 0.0181929 44.8298C0.0853861 47.5937 0.672339 51.6042 6.93514 51.5259C9.70127 51.4915 31.8823 52.1796 35.767 51.638C39.6523 51.0964 42.1102 50.461 41.9962 44.9723C41.8822 39.4842 41.7874 10.9974 41.6451 6.92811Z",
    fill: "#F4F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3214 6.78175C38.3214 5.19498 37.0662 3.9082 35.5174 3.9082C30.5939 3.9082 20.5949 3.9082 17.1954 3.9082C16.451 3.9082 15.7386 4.21039 15.2124 4.74994C12.9254 7.09493 6.49857 13.6816 4.21156 16.0265C3.6853 16.565 3.39062 17.2968 3.39062 18.0584C3.39062 22.5813 3.39062 38.7765 3.39062 45.4191C3.39062 46.1817 3.6853 46.9125 4.21156 47.452C4.73782 47.9905 5.45019 48.2938 6.1946 48.2938H35.5174C37.0662 48.2938 38.3214 47.007 38.3214 45.4191C38.3214 37.3941 38.3214 14.8079 38.3214 6.78175Z",
    fill: "#DDEAF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3575 4.72596C16.3575 4.5388 16.2463 4.369 16.0782 4.29711C15.909 4.22523 15.7143 4.26489 15.5849 4.39751C13.2792 6.7611 6.45625 13.7552 4.00783 16.2651C3.85911 16.4175 3.81436 16.6468 3.89536 16.8463C3.97516 17.0459 4.165 17.1748 4.37538 17.1748C6.62551 17.1748 11.3688 17.1748 14.1655 17.1748C14.747 17.1748 15.3044 16.9393 15.7155 16.5179C16.1266 16.0965 16.3575 15.5251 16.3575 14.9289V4.72596Z",
    fill: "#575C69"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4407 4.59411C16.4238 4.41564 16.3089 4.26195 16.1433 4.20122C15.9788 4.14049 15.7939 4.18262 15.6705 4.30905C13.4373 6.59827 6.34355 13.87 3.92777 16.3464C3.82137 16.4555 3.79718 16.624 3.86973 16.7591C3.94228 16.8955 4.0922 16.9673 4.23971 16.9339C6.66516 16.4034 12.3999 15.1479 15.4009 14.491C16.4879 14.253 17.2291 13.2181 17.1251 12.084C16.9207 9.84558 16.5967 6.30081 16.4407 4.59411Z",
    fill: "#BCCDD9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.408 9.29408H31.6673C31.94 9.29408 32.1613 9.06734 32.1613 8.78767C32.1613 8.50799 31.94 8.28125 31.6673 8.28125H22.408C22.1353 8.28125 21.9141 8.50799 21.9141 8.78767C21.9141 9.06734 22.1353 9.29408 22.408 9.29408Z",
    fill: "#575C69"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.87378 22.8937H34.6516C35.4402 22.8937 36.0801 22.667 36.0801 22.3873C36.0801 22.1076 35.4402 21.8809 34.6516 21.8809H7.87378C7.08524 21.8809 6.44531 22.1076 6.44531 22.3873C6.44531 22.667 7.08524 22.8937 7.87378 22.8937Z",
    fill: "#575C69"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4084 13.6359H26.5126C26.7855 13.6359 27.0069 13.4091 27.0069 13.1295C27.0069 12.8498 26.7855 12.623 26.5126 12.623H22.4084C22.1355 12.623 21.9141 12.8498 21.9141 13.1295C21.9141 13.4091 22.1355 13.6359 22.4084 13.6359Z",
    fill: "#575C69"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84031 27.2685H19.5195C20.2962 27.2685 20.9263 26.9662 20.9263 26.5933C20.9263 26.2203 20.2962 25.918 19.5195 25.918H7.84031C7.06367 25.918 6.43359 26.2203 6.43359 26.5933C6.43359 26.9662 7.06367 27.2685 7.84031 27.2685Z",
    fill: "#575C69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.2662b654d0da054dbd26eddf58c60c7c.svg";
export { ForwardRef as ReactComponent };